import { Box } from '@mui/material';
import Link from 'next/link';
import React from 'react';

import useBreakpoints from '../../../ui/hooks/useBreakpoints';

export type CTAButtonProps = {
  href: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  rel?: string;
  color?: 'primary' | 'secondary';
  icon?: React.ReactNode;
  label: string;
}
export const CTAButton = ({ href, target, rel, color, icon, label }: CTAButtonProps) => {
  const { md } = useBreakpoints();

  return (
    <Link
      passHref
      href={href}
      target={target}
      rel={rel}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        backgroundColor: color === 'primary' ? '#080808' : '#ffffff',
        color: color === 'primary' ? '#ffffff' : '#080808',
        textDecoration: 'none',
        borderRadius: '30px',
        padding: md ? '16px 24px' : '12px 16px',
        lineHeight: 1.4,
        height: 'auto',
        marginRight: '16px',
        fontSize: md ? '20px' : '14px',
        border: 0,
      }}
    >
      {icon && (
        <Box sx={{ marginRight: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {icon}
        </Box>
      )}
      {label}
    </Link>
  );
};
